import { PageLink } from 'assets/layout/core'

export const breadcrumbList: PageLink[] = [
  {
    title: 'Ingredientes',
    path: '/commercial/ingredients',
    isSeparator: false,
    isActive: false
  },
  {
    title: '',
    path: '',
    isSeparator: true,
    isActive: false
  }
]
